import React, {useEffect, useCallback, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import dateformat from 'dateformat';
import {logPageLoadEvents} from '@ibibo/analytics';


import {
  fetchModifyHotelDetails,
  fetchModifyDetails,
  confirmAmmendment,

  myTripModifyHotelDataSelector,
  myTripDetailsParamsSelector,
  activeModifyTabSelector,
  myTripModifyDetailsSelector,
  selectedRefundModeSelector,
  myTripModifyStatusSelector,

  updateActiveModifyTab,
  updateCancellationRefundMode,
  updateModifyStatus
} from '@ibibo/myaccount-reducer';
import {loadNewPaymentsOptions} from '@ibibo/load-payments';

import * as S from './RescheduleFlow.styles';

import Modal, {useModal} from '../../../../../hotels-dweb/src/shared/components/Modal';

import RescheduleLeftBlock from '../../../stories/components/RescheduleFlow/RescheduleLeftBlock/RescheduleLeft';
import ConfirmReschedulePop from '../../../stories/components/RescheduleFlow/ConfirmReschedulePopup/ConfirmReschedulePop';
import CancelStatusPop from '../../../stories/components/CancelFlow/CancelStatusPop/CancelStatusPop';
// import RescheduleRightBlock from '../../../stories/components/RescheduleFlow/RescheduleRightBlock/RescheduleRightBlock';

const RescheduleFlow = () => {
  const dispatch = useDispatch();

  const detailsParams = useSelector(myTripDetailsParamsSelector);
  const modifyDetails = useSelector(myTripModifyDetailsSelector);
  const modifyHotelData = useSelector(myTripModifyHotelDataSelector);
  const activeTab = useSelector(activeModifyTabSelector);
  const selectedRefundMode = useSelector(selectedRefundModeSelector);
  const modifyStatus = useSelector(myTripModifyStatusSelector);

  const {fare_list = [], status_msg = null, refund = false, refund_breakup, success, details={}} = modifyDetails;

  const [params, setParams] = useState(null);
  const [paySessionId, setPaySessionId] = useState('');

  const {isModalOpen: isConfirmModalOpen, closeModal: closeConfirmModal, openModal: openConfirmModal} = useModal();
  const {isModalOpen: isStatusModalOpen, closeModal: closeStatusModal, openModal: openStatusModal} = useModal();
  
  const fetchHotelDetailsCaller = useCallback(() => {
    return dispatch(fetchModifyHotelDetails(detailsParams));
  }, [dispatch]);

  useEffect(() => {
    if (success && !refund) {
      loadNewPaymentsOptions();
    }
  }, [success]);
  
  useEffect(() => {
    fetchHotelDetailsCaller();
    if (modifyStatus) {
      openStatusModal();
    }
  }, []);

  useEffect(() => {
    let searchType = '';
    if(modifyHotelData && modifyHotelData.hotel_country_name){
      if(modifyHotelData.hotel_country_name !== "India"){
        searchType = 'intl';
      } else {
        searchType = 'domestic'
      }
      logPageLoadEvents(`postbooking:${searchType} hotels mybookings:modifybooking`, {});
    }
  }, [modifyHotelData]);

  useEffect(() => {
    if (modifyStatus) {
      openStatusModal();
    }
  }, [modifyStatus]);
  
  useEffect(() => {
    if (modifyHotelData) {
      setParams({
        checkin: {date: modifyHotelData.checkin_date},
        checkout: {date: modifyHotelData.checkout_date},
        guestDetails: modifyHotelData.guest_details
      });
    }
  }, [modifyHotelData]);
  
  if (!params) {
    return null;
  }
  
  const fetchModifyDetailsCaller = () => {
    const queryStr = `query=hotels-${modifyHotelData.city_id}-${dateformat(params.checkin.date, 'yyyymmdd')}-${dateformat(params.checkout.date, 'yyyymmdd')}-${getPaxString(params.guestDetails)}&booking_id=${detailsParams.parentID}`;
    dispatch(fetchModifyDetails(queryStr));
  };
  
  const confirmCaller = () => {
    const query = `query=hotels-${modifyHotelData.city_id}-${dateformat(params.checkin.date, 'yyyymmdd')}-${dateformat(params.checkout.date, 'yyyymmdd')}-${getPaxString(params.guestDetails)}&booking_id=${detailsParams.parentID}`;
    dispatch(confirmAmmendment({
      pay_option: (selectedRefundMode === 'wallet' ? 2 : 1),
      booking_id: detailsParams.parentID,
      details: modifyDetails.details
    }, query, successCallback, errorCallback));
  };

  const successCallback = (resp) => {
    if (resp.pay_session_id) {
      setPaySessionId(resp.pay_session_id);
      dispatch(updateActiveModifyTab('pay'));
    }
    if (typeof resp.amended !== 'undefined') {
      dispatch(updateModifyStatus({
        amended: resp.amended || false,
        msg: resp.message || '',
        status_color: resp.status_color || 'yellow',
        sub_msg: resp.sub_msg || ''
      }));
      openStatusModal();
    }
  }
  
  const errorCallback = (resp) => {
    dispatch(updateModifyStatus({
      amended: false,
      msg: resp.message || 'Something Went Wrong.',
      status_color: resp.status_color || 'red',
      sub_msg: resp.sub_msg || ''
    }));
    openStatusModal();
  }

  const getPaxString = (guestDetails) => {
    // eg: 3-1_0-2_1_3-1_2_4_5
    // rooms (3-*): 3
    // room1 (*-1_0-*): 1 adult | 0 child
    // room2 (*-2_1_3-*): 2 adults | 1 child of age 3
    // room3 (*-1_2_4_5-*): 1 adult | 2 children of age 4 and 5
    const rooms = guestDetails.length;
    let str = `${rooms}-`;
    for (let i = 0; i < guestDetails.length; i++) {
      if (i > 0) str += '-';
      const {adults, childs} = guestDetails[i];
      str += `${adults}_${childs.length}`;
      for (let j = 0; j < childs.length; j++) {
        str += `_${childs[j].age}`;
      }
    }
    return str;
  }

  const updateParams = (data) => {
    setParams({...params, ...data});
  }

  const updateActiveTab = (tab) => {
    if (tab === 'pay') {
      openConfirmModal();
      // confirmReschedule();
    } else {
      dispatch(updateActiveModifyTab(tab));
    }
  }

  const confirmReschedule = () => {
    closeConfirmModal();
    confirmCaller();
  }

  const updateRefundMode = (mode) => {
    dispatch(updateCancellationRefundMode(mode));
  }

  const navigateToMyTrips = () => {
    window.open('/mytrips/', '_self');
  }

  let isCheckAvailabilityDisabled = true;
  if (!(new Date(params.checkin.date).getTime() === new Date(modifyHotelData.checkin_date).getTime() &&
      new Date(params.checkout.date).getTime() === new Date(modifyHotelData.checkout_date).getTime() &&
      JSON.stringify(params.guestDetails) === JSON.stringify(modifyHotelData.guest_details))) {
        isCheckAvailabilityDisabled = false;
  }

  return(
    <S.RescheduleMainWrapper>
      <S.RescheduleOuterWrap>
        <RescheduleLeftBlock
          activeTab={activeTab}
          dateInfo={{
            checkin: params.checkin.date,
            checkout: params.checkout.date,
          }}
          roomInfo={{
            roomAmenities: modifyHotelData.room_amenities,
            roomName: modifyHotelData.room_name,
            guestDetails: params.guestDetails
          }}
          hotelInfo={{
            hotelName: modifyHotelData.hotel_name,
            checkin: modifyHotelData.checkin_date,
            checkout: modifyHotelData.checkout_date
          }}
          updatedHotelDetails={{
            hotelImage: modifyHotelData.hotel_image,
            roomName: modifyHotelData.room_name,
            roomAmenities: modifyHotelData.room_amenities,
            guestDetails: details
          }}
          fcdt={modifyHotelData.fcdt_text}
          isCheckAvailabilityDisabled={isCheckAvailabilityDisabled}
          updateParams={updateParams}
          checkAvailability={fetchModifyDetailsCaller}
          updateActiveTab={updateActiveTab}
          fareList={fare_list}
          statusMsg={status_msg}
          hasRefund={refund}
          refundBreakup={refund_breakup}
          modifyAllowed={success}
          paySessionId={paySessionId}
          confirmReschedule={openConfirmModal}
          selectedRefundMode={selectedRefundMode}
          updateRefundMode={updateRefundMode}
        />
        {/* <RescheduleRightBlock /> */}
      </S.RescheduleOuterWrap>
      <Modal
        isOpen={isConfirmModalOpen}
        closeModal={closeConfirmModal}
        modalStyles={{
          width: 'auto',
        }}
      >
        <ConfirmReschedulePop confirmReschedule={confirmReschedule} closeModal={closeConfirmModal} />
      </Modal>
      <Modal
        isOpen={isStatusModalOpen}
        closeModal={navigateToMyTrips}
        modalStyles={{
          width: 'auto',
        }}
      >
        <CancelStatusPop data={modifyStatus} navigateToMyTrips={navigateToMyTrips} />
      </Modal>
    </S.RescheduleMainWrapper>
  );
}

export default RescheduleFlow;
